import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    endAdornmentText: {
      color: COLORS.gray.gray50,
      whiteSpace: 'nowrap',
      marginLeft: theme.spacing(1),
    },
    input: {
      width: 180,
    },
  }),
  { name: 'FieldMaxChars' }
);
